import { FirebaseStorage, ref, uploadString } from "@firebase/storage";

import { BaseNamesType } from "@/domain/models/storage";
import { dateAsDayjs } from "@/src/utils/date";

export const StorageApi = {
  uploadServicePhoto: async ({
    storage,
    jobId,
    serviceId,
    baseName,
    base64PhotoString,
  }: {
    jobId: string;
    serviceId: string;
    baseName: BaseNamesType;
    storage: FirebaseStorage;
    base64PhotoString: string;
  }) => {
    try {
      const path = `jobs/${jobId}/services/${serviceId}/${baseName}-${dateAsDayjs().valueOf()}.jpg`;

      const storageRef = ref(storage, path);

      const snapshot = await uploadString(
        storageRef,
        base64PhotoString,
        "data_url",
      );
      return snapshot.ref.fullPath;
    } catch (error) {
      console.error("Error uploading photo", error);
      throw error;
    }
  },
};
